const categories = [
    {
        path: '/core-categories/list',
        name: 'core.categories.list',
        component: () => import('@/views/Categories/CoreCategories/view/List.vue'),
        meta: {
            roles: [1, 2, 5, 6],
            pageTitle: 'Categorias Padrões',
        },
    },
]

export default categories
